import * as React from "react";
import { classes, style } from "typestyle";
import { FunctionComponent, ReactNode } from "react";
import { Black, White } from "@traceair/tds";

export interface IMapControlProps {
  children: ReactNode;
  className: string;
}

const MapControl: FunctionComponent<IMapControlProps> = ({
  className,
  children,
}: IMapControlProps) => {
  return (
    <div className={classes(buttonStyle, regularStyle, className)}>
      {children}
    </div>
  );
};

export default MapControl;

export const regularStyle = style({
  fontFamily: "Roboto",
  fontSize: 14,
  lineHeight: "16px",
});

const buttonStyle = style({
  color: Black,
  background: White,
  fontSize: "14px",
  lineHeight: "16px",
  borderRadius: "12px",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 24,
  height: 36,
  outline: "none",
  border: "none",
  $nest: {
    "&:hover": {
      textDecoration: "none",
    },
    "&:focus": {
      textDecoration: "none",
    },
    "& > span": {
      color: Black,
    },
  },
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.3)",
});
